// @flow

import type { BasicProps } from '../../type'

import * as React from 'react'
import { appendPropsSchema, appendPropsActions } from '../util/schemaUtil'

type Props = BasicProps & {
  styledJsx: string,
  id: string
};

export default function (WrappedComponent: React.ComponentType<*>) {
  class StyleJsx extends React.PureComponent<Props> {
    wrappedComponent: ?React.Component<*>;

    static actions = appendPropsActions(WrappedComponent);

    static schema = appendPropsSchema(WrappedComponent, [
      {
        key: 'styledJsx',
        type: 'code',
        title: '自定义样式'
      }
    ]);

    constructor (props: Props) {
      super(props)
      let { id, styledJsx } = this.props
      if (!styledJsx) return
      styledJsx = styledJsx.replace(/[\r\n]/g, '')
      styledJsx = styledJsx.replace(/(.+?\{.+?\})/g, `#${id} $1`)
      var nod = document.createElement('style')
      nod.type = 'text/css'
      nod.innerHTML = styledJsx
      document.getElementsByTagName('head')[0].appendChild(nod)
    }

    render () {
      return (
        <WrappedComponent
          ref={ref => {
            this.wrappedComponent = ref
          }}
          {...this.props}
        />
      )
    }
  }

  return StyleJsx
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/hoc/styledJsx.js